
import { Component, Emit, Vue } from 'vue-property-decorator'
import '../../dynamsoft.config'
import {
  CameraEnhancer,
  CameraView,
  CaptureVisionRouter, EnumCapturedResultItemType,
  EnumDeblurMode,
  EnumLocalizationMode,
  MultiFrameResultCrossFilter,
  SimplifiedBarcodeReaderSettings,
  SimplifiedCaptureVisionSettings
} from 'dynamsoft-barcode-reader-bundle'

const DYNAMSOFT_TEMPLATE_NAME = 'ReadSingleBarcode'

@Component
export default class DynamsoftBarcodeScanner extends Vue {

  public $refs!: {
    container: HTMLFormElement
  }

  public $data!: {
    cameraEnhancer: CameraEnhancer,
    captureVisionRouter: CaptureVisionRouter,
    cameraView: CameraView
  }

  public error: string = ''
  public barcodeScanner: CameraEnhancer | null = null

  public cameraEnhancer: CameraEnhancer | null = null
  public captureVisionRouter: CaptureVisionRouter | null = null
  public cameraView: CameraView | null = null

  public async mounted() {

    try {
      this.$data.cameraView = await CameraView.createInstance(this.$refs.container)
      this.$data.cameraEnhancer = await CameraEnhancer.createInstance(this.$data.cameraView)
      this.$data.captureVisionRouter = await CaptureVisionRouter.createInstance()
      this.barcodeScanner = this.$data.cameraEnhancer

      await this.updateSettings(this.$data.captureVisionRouter)

      this.$data.captureVisionRouter.setInput(this.$data.cameraEnhancer)
      this.$data.captureVisionRouter.addResultReceiver({
        onDecodedBarcodesReceived: (result) => {
          if (!result.barcodeResultItems || result.barcodeResultItems.length === 0) {
            return
          }
          this.scanned(result.barcodeResultItems[0].text)
        }
      })

      const filter = new MultiFrameResultCrossFilter()
      filter.enableResultCrossVerification('barcode', true)
      filter.enableResultDeduplication('barcode', true)
      filter.setDuplicateForgetTime(EnumCapturedResultItemType.CRIT_BARCODE, 1000)
      await this.$data.captureVisionRouter.addResultFilter(filter)
      await this.$data.cameraEnhancer.open()
      await this.$data.captureVisionRouter.startCapturing(DYNAMSOFT_TEMPLATE_NAME)
    } catch (ex) {
      console.error(ex)
    }
  }

  @Emit('scanned')
  public scanned(barcode: string) {
    console.log('Scanned', barcode)
    if (this.$data.cameraEnhancer) {
      this.$data.cameraEnhancer.close()
    }
  }

  public async startScanning() {
    console.log('Starting Scanning...')
    if (this.$data.cameraEnhancer) {
      await this.$data.cameraEnhancer.open()
    }
  }

  public stopScanning() {
    console.log('Stopped Scanning...')
    if (this.$data.cameraEnhancer) {
      this.$data.cameraEnhancer.close()
    }
  }

  public async resetScanner() {
    console.log('Reset Scanner...')
    if (this.$data.cameraEnhancer) {
      await this.$data.cameraEnhancer.open()
      await this.$data.captureVisionRouter.startCapturing(DYNAMSOFT_TEMPLATE_NAME)
    }
  }

  protected async updateSettings(cvRouter: CaptureVisionRouter) {
    const settings: SimplifiedCaptureVisionSettings = await cvRouter.getSimplifiedSettings(DYNAMSOFT_TEMPLATE_NAME)
    settings.minImageCaptureInterval = 500
    // settings.barcodeSettings = {
    //   expectedBarcodesCount: 1,
    //   localizationModes: [
    //     EnumLocalizationMode.LM_CONNECTED_BLOCKS,
    //     EnumLocalizationMode.LM_SCAN_DIRECTLY,
    //     EnumLocalizationMode.LM_LINES,
    //     0,
    //     0,
    //     0,
    //     0,
    //     0
    //   ],
    //   deblurModes: [EnumDeblurMode.DM_SKIP],
    //   minResultConfidence: 30
    // } as SimplifiedBarcodeReaderSettings

    return cvRouter.updateSettings(DYNAMSOFT_TEMPLATE_NAME, settings)
  }

  // protected dispose() {
  //   if (this.captureVisionRouter) {
  //     this.captureVisionRouter.stopCapturing()
  //     this.captureVisionRouter.dispose()
  //   }
  //   if (this.cameraEnhancer) {
  //     this.cameraEnhancer.stopFetching()
  //     this.cameraEnhancer.dispose()
  //   }
  // }

  // protected async updateSettings(scanner: any) {
  //   const settings = await scanner.getRuntimeSettings()
  //
  //   settings.localizationModes = [
  //     Dynamsoft.EnumLocalizationMode.LM_CONNECTED_BLOCKS,
  //     Dynamsoft.EnumLocalizationMode.LM_SCAN_DIRECTLY,
  //     Dynamsoft.EnumLocalizationMode.LM_LINES, 0, 0, 0, 0, 0]
  //   settings.deblurLevel = 0
  //   settings.minResultConfidence = 30
  //
  //   await scanner.updateRuntimeSettings(settings)
  //
  //   const scanSettings = await scanner.getScanSettings()
  //   scanSettings.duplicateForgetTime = 500
  //   await scanner.updateScanSettings(scanSettings)
  // }
}
